import DataTableNativeML from './DataTableNativeML';

export default (props) => {
  return <DataTableNativeML {...props} />;
};
